// extracted by mini-css-extract-plugin
module.exports = {"nextButton":"styles_nextButton___Lto0","darkTheme":"styles_darkTheme__bko9Y"};